module.exports = __webpack_public_path__ + "static/media/ecos_kopenhagen_1_1.69e70817.jpg";